import { ActionContext } from 'vuex'
import apiAdminMission from '@/api/admin/adminMission'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IAdminMissionState } from './state'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloDbMission } from '@/models/alodb/AloDbMission'
import { AloError } from '@/models/alo/AloError'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { router } from '@/mainjs.js'
import { WobAdminChanged } from '@/models/wob/WobAdminChanged'
import { AloDbRoleMapping } from '@/models/alodb/AloDbRoleMapping'
import { i18n } from '@/locale/vueI18n'

export class AdminMissionAction {
  public [types.ADMINMISSION_REQUEST](context: ActionContext<IAdminMissionState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.ADMINMISSION_REQUEST)
      apiAdminMission
        .getAdminMissions()
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const adminMissionArray = resp.data.data as AloBaseArray<AloDbMission>
            context.commit(types.ADMINMISSION_SUCCESS, adminMissionArray.items)
            resolve(adminMissionArray.items)
          } else {
            context.commit(types.ADMINMISSION_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.ADMINMISSION_ERROR)
          reject()
        })
    })
  }

  public [types.ADMINMISSION_ENSURE_LIST](context: ActionContext<IAdminMissionState, IRootState>) {
    if (context.state.adminMissions.length == 0) {
      return context.dispatch(types.ADMINMISSION_REQUEST)
    } else {
      return new Promise((resolve, reject) => {
        resolve(context.state.adminMissions)
      })
    }
  }

  public [types.ADMINMISSION_SELECT_DETAIL](context: ActionContext<IAdminMissionState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      const adminMission = context.getters.adminMissionsById[itemId] as AloDbMission
      if (adminMission) {
        if (adminMission.detailLoaded) {
          context.commit(types.ADMINMISSION_SELECT_DETAIL, adminMission)
          resolve(adminMission)
        } else {
          context.dispatch(types.ADMINMISSION_SELECT_DETAIL_REQUEST, itemId).then(ens => {
            context.commit(types.ADMINMISSION_SELECT_DETAIL, ens)
            resolve(ens)
          })
        }
      } else {
        const newAdminMission = new AloDbMission()
        context.commit(types.ADMINMISSION_SELECT_DETAIL, newAdminMission)
        resolve(newAdminMission)
      }
    })
  }

  public [types.ADMINMISSION_SELECT_DETAIL_REQUEST](
    context: ActionContext<IAdminMissionState, IRootState>,
    itemId: number,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.ADMINMISSION_SELECT_DETAIL_REQUEST, itemId)
      apiAdminMission
        .getAdminMission(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const adminMission = resp.data.data as AloDbMission
            context.commit(types.ADMINMISSION_SELECT_DETAIL_SUCCESS, adminMission)
            context.commit(types.ADMINMISSION_SELECT_DETAIL, adminMission)
            resolve(adminMission)
          } else {
            context.commit(types.ADMINMISSION_SELECT_DETAIL_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(() => {
          context.commit(types.ADMINMISSION_SELECT_DETAIL_ERROR)
          reject()
        })
    })
  }

  public [types.ADMINMISSION_SAVE_REQUEST](context: ActionContext<IAdminMissionState, IRootState>) {
    return new Promise((resolve, reject) => {
      const tryRedirect = !context.state.modifiedAdmAdminMission.id
      context.commit(types.ADMINMISSION_SAVE_REQUEST, context.state.modifiedAdmAdminMission.MIS_LIBELLE)
      apiAdminMission
        .saveAdminMission(context.state.modifiedAdmAdminMission)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const adminMission = resp.data.data as AloDbMission
            context.commit(types.ADMINMISSION_SELECT_DETAIL_SUCCESS, adminMission)
            context.commit(types.ADMINMISSION_SELECT_DETAIL, adminMission)
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.SaveOk', { item: adminMission.MIS_LIBELLE }))
            if (tryRedirect && router.app.$route.name === 'NewAdminMission') {
              router.push({ name: 'EditAdminMission', params: { itemid: adminMission.id!.toString() } })
            }
            resolve(adminMission)
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.ADMINMISSION_SAVE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: error.errorMessage }))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.ADMINMISSION_SAVE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: er.errorMessage }))
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.ADMINMISSION_DELETE_REQUEST](context: ActionContext<IAdminMissionState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      const misId = context.state.originalAdmAdminMission.MIS_ID!
      const misLibelle = context.state.originalAdmAdminMission.MIS_LIBELLE
      context.commit(types.ADMINMISSION_DELETE_REQUEST, misLibelle)
      apiAdminMission
        .deleteAdminMission(misId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context.commit(types.ADMINMISSION_DELETE_SUCCESS, misId)
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.DeleteOk', { item: misLibelle }))
            if (
              router.app.$route.name === 'EditAdminMission' &&
              context.state.originalAdmAdminMission.MIS_ID! == misId
            ) {
              router.push({ name: 'NewAdminMission' })
            }
            resolve()
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.ADMINMISSION_DELETE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: error.errorMessage }))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.ADMINMISSION_DELETE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: er.errorMessage }))
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.ADMINMISSION_UPDATE_MODIFIED_ADM](
    context: ActionContext<IAdminMissionState, IRootState>,
    newProperties: Object,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.ADMINMISSION_UPDATE_MODIFIED_ADM, newProperties)
      resolve(context.state.modifiedAdmAdminMission)
    })
  }

  public [types.ADMINMISSION_CANCEL_MODIFIED_ADM](context: ActionContext<IAdminMissionState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.ADMINMISSION_SELECT_DETAIL, context.state.originalAdmAdminMission)
      resolve(context.state.modifiedAdmAdminMission)
    })
  }

  public [types.ADMINMISSION_UPDATE_FILTER_ADM](
    context: ActionContext<IAdminMissionState, IRootState>,
    newProperties: Object,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.ADMINMISSION_UPDATE_FILTER_ADM, newProperties)
      resolve(context.state.adminFilter)
    })
  }

  public [types.ADMINMISSION_EXTERNAL_UPDATE](
    context: ActionContext<IAdminMissionState, IRootState>,
    wob: WobAdminChanged<AloDbMission>,
  ) {
    return new Promise<void>((resolve, reject) => {
      if (wob.actionType == 'Deleted') {
        context.dispatch(types.MISSION_DELETE, wob.oldAloDbItem.MIS_ID)
      }
      context.commit(types.ADMINMISSION_EXTERNAL_UPDATE, wob)
      resolve()
    })
  }

  public [types.ADMINMISSION_ROLEMAPPING_REQUEST](
    context: ActionContext<IAdminMissionState, IRootState>,
    { itemId, explicit }: { itemId: number; explicit: boolean },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.ADMINMISSION_ROLEMAPPING_REQUEST, itemId)
      apiAdminMission
        .getAdminMissionRoleMap(itemId, explicit)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const rolesMappingArray = resp.data.data as AloBaseArray<AloDbRoleMapping>
            context.commit(types.ADMINMISSION_ROLEMAPPING_SUCCESS, rolesMappingArray.items)
            resolve(rolesMappingArray.items)
          } else {
            context.commit(types.ADMINMISSION_ROLEMAPPING_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.ADMINMISSION_ROLEMAPPING_ERROR)
          reject()
        })
    })
  }

  public [types.ADMINMISSION_ROLEMAPPING_EXTERNAL_UPDATE](
    context: ActionContext<IAdminMissionState, IRootState>,
    wob: WobAdminChanged<AloDbRoleMapping>,
  ) {
    return new Promise<void>((resolve, reject) => {
      if (wob.actionType == 'Deleted') {
        context.commit(types.ADMINMISSION_REMOVE_ROLEMAPPING_SUCCESS, wob.oldAloDbItem)
      } else {
        context.commit(types.ADMINMISSION_ADD_ROLEMAPPING_SUCCESS, wob.newAloDbItem)
      }
      resolve()
    })
  }

  public [types.ADMINMISSION_ENSURE_ROLEMAPPING](
    context: ActionContext<IAdminMissionState, IRootState>,
    { itemId, explicit }: { itemId: number; explicit: boolean },
  ) {
    if (
      context.state.modifiedAdmAdminMissionRolesMapping.length == 0 ||
      context.state.modifiedAdmAdminMissionRolesMapping[0].MAP_ID != itemId
    ) {
      return context.dispatch(types.ADMINMISSION_ROLEMAPPING_REQUEST, { itemId, explicit })
    } else {
      return new Promise((resolve, reject) => {
        resolve(context.state.modifiedAdmAdminMissionRolesMapping)
      })
    }
  }
}

export default util.classToObject(AdminMissionAction)
